<input
  type="checkbox"
  class="mr-2 ml-2"
  [checked]="item?.checked"
  (change)="onChange()" />

{{ item.nome }}